module.exports = __webpack_public_path__ + "img/heavenly backup dancers.fd46f339.png";